import axios from "axios";
import {
	AddBankAccountResponse,
	BenefitLimitsResponse,
	BenefitLimitsShortExplanationsResponse, DeleteDependentResponse, ListConditionsWithKeywordResponse,
	PersonalizePlanResponse,
	PrepareAppResponse,
	PrepareReviewResponse,
	PrepareSummaryResponse,
	ResetPasswordResponse,
	ResetTokenResponse,
	SearchConditionsResponse,
	SubmitPlanDetailsResponse,
	SubmitPlanInfoResponse,
	UnsubscribeResponse,
	UpsertDependentResponse,
	UpsertUserProgressResponse,
	ValidateEmployerPasscodeResponse,
	VerifyIdentityBenAdminResponse,
	VerifyIdentityResponse,
} from "./types";
import {API_URL} from "../utils/config";

const headers = {'Content-Type': 'application/json'};

/**
 * @param {PrepareAppRequest} prepareAppRequest
 * @returns {Promise<?PrepareAppResponse>}
 */
export const prepareApp = async prepareAppRequest => {
	const response = await axios.post(`${API_URL}/prepareApp`, prepareAppRequest, {headers});
	return response ? new PrepareAppResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
};

/**
 * @param {BenefitLimitsRequest} benefitLimitsRequest
 * @returns {Promise<?BenefitLimitsResponse>}
 */
export const benefitLimitsService = async benefitLimitsRequest => {
	const response = await axios.post(`${API_URL}/getBenefitLimits`, benefitLimitsRequest, {headers});
	return response ? new BenefitLimitsResponse(response.data) : null;
}

/**
 * @param {ValidateEmployerPasscodeRequest} validateEmployerPasscodeRequest
 * @returns {Promise<?ValidateEmployerPasscodeResponse>}
 */
export const validateEmployerPasscode = async validateEmployerPasscodeRequest => {
	const response = await axios.post(`${API_URL}/validateEmployerPasscode`, validateEmployerPasscodeRequest, {headers});
	return response ? new ValidateEmployerPasscodeResponse(response) : null;
}

/**
 * @param {VerifyIdentityBenAdminRequest} verifyIdentityBenAdminRequest
 * @returns {Promise<?VerifyIdentityBenAdminResponse>}
 */
export const verifyIdentityBenAdmin = async verifyIdentityBenAdminRequest => {
	const response = await axios.post(`${API_URL}/verifyIdentityBenAdmin`, verifyIdentityBenAdminRequest, {headers});
	return response ? new VerifyIdentityBenAdminResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {VerifyIdentityRequest} verifyIdentityRequest
 * @returns {Promise<?VerifyIdentityResponse>}
 */
export const verifyIdentity = async verifyIdentityRequest => {
	const response = await axios.post(`${API_URL}/verifyIdentity`, verifyIdentityRequest, {headers});
	return response ? new VerifyIdentityResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {RegisterActionRequest} registerActionRequest
 * @returns {Promise<void>}
 */
export const sendRegisterAction = async registerActionRequest => {
	await axios.post(`${API_URL}/registerAction`, registerActionRequest, {headers});
};

/**
 * @param {UpsertUserProgressRequest} upsertUserProgressRequest
 * @returns {Promise<?UpsertUserProgressResponse>}
 */
export const upsertUserProgress = async upsertUserProgressRequest => {
	const response = await axios.post(`${API_URL}/upsertUserProgress`, upsertUserProgressRequest, {headers});
	return response ? new UpsertUserProgressResponse(response) : null;
}

/**
 * @param {PrepareDiagnosisRequest} prepareDiagnosisRequest
 * @returns {Promise<AxiosResponse<PrepareDiagnosisResponse>>}
 */
export const prepareDiagnosisService = prepareDiagnosisRequest => {
	return axios.post(`${API_URL}/prepareDiagnosis`, prepareDiagnosisRequest, {headers});
};

/**
 * @param {BenefitLimitsShortExplanationsRequest} benefitLimitsShortExplanationsRequest
 * @returns {Promise<?BenefitLimitsShortExplanationsResponse>}
 */
export const benefitLimitsShortExplanations = async benefitLimitsShortExplanationsRequest => {
	const response = await axios.post(`${API_URL}/getBenefitLimitsShortExplanations`, benefitLimitsShortExplanationsRequest, {headers});
    return response ? new BenefitLimitsShortExplanationsResponse(response.data) : null;
}

/**
 * @param {PersonalizePlanRequest} personalizePlanRequest
 * @returns {Promise<?PersonalizePlanResponse>}
 */
export const getPersonalizePlan = async personalizePlanRequest => {
	const response = await axios.post(`${API_URL}/personalizePlan`, personalizePlanRequest, {headers});
	return response ? new PersonalizePlanResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {SubmitPlanDetailsRequest} submitPlanDetailsRequest
 * @returns {Promise<?SubmitPlanDetailsResponse>}
 */

export const submitPlanDetails = async submitPlanDetailsRequest => {
	const response = await axios.post(`${API_URL}/submitPlanDetails`, submitPlanDetailsRequest, {headers});
	return response ? new SubmitPlanDetailsResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {UpsertDependentRequest} upsertDependentRequest
 * @returns {Promise<?UpsertDependentResponse>}
 */
export const upsertDependentService = async upsertDependentRequest => {
	const response = await axios.post(`${API_URL}/upsertDependent`, upsertDependentRequest, {headers});
	return response ? new UpsertDependentResponse(response.data) : null;
}

/**
 * @param {DeleteDependentRequest} deleteDependentRequest
 * @returns {Promise<?DeleteDependentResponse>}
 */
export const deleteDependentService = async deleteDependentRequest => {
	const response = await axios.post(`${API_URL}/deleteDependent`, deleteDependentRequest, {headers});
	return response ? new DeleteDependentResponse(response.data) : null;
}

/**
 * @param {PrepareReviewRequest} prepareReviewRequest
 * @returns {Promise<?PrepareReviewResponse>}
 */
export const getPrepareReview = async prepareReviewRequest => {
	const response = await axios.post(`${API_URL}/prepareReview`, prepareReviewRequest, {headers});
	return response ? new PrepareReviewResponse(response.data) : null;
}

/**
 * @param {SearchConditionsRequest} searchConditionsRequest
 * @returns {Promise<?SearchConditionsResponse>}
 */
export const searchConditions = async searchConditionsRequest => {
	const response = await axios.post(`${API_URL}/searchCondition`, searchConditionsRequest, {headers});
	return response ? new SearchConditionsResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
};

/**
 * @param {ResetTokenRequest} resetTokenRequest
 * @returns {Promise<?ResetTokenResponse>}
 */
export const resetToken = async resetTokenRequest => {
	const response = await axios.post(`${API_URL}/resetToken`, resetTokenRequest, {headers});
	return response ? new ResetTokenResponse({
		status: response.status,
		...response.data
	}) : null;
}

/**
 * @param {RequestResetPasswordRequest} requestResetPasswordRequest
 * @returns {Promise<void>}
 */
export const requestResetPassword = async requestResetPasswordRequest => {
	await axios.post(`${API_URL}/requestResetPassword`, requestResetPasswordRequest, {headers});
}

/**
 * @param {SubmitCaseRequest} submitCaseRequest
 * @returns {Promise<void>}
 */
export const submitCase = async submitCaseRequest => {
	await axios.post(`${API_URL}/submitCase`, submitCaseRequest, {headers});
}

/**
 * @param {ResetPasswordRequest} resetPasswordRequest
 * @returns {Promise<?ResetPasswordResponse>}
 */
export const resetPassword = async resetPasswordRequest => {
	const response = await axios.post(`${API_URL}/resetPassword`, resetPasswordRequest, {headers});
	return response ? new ResetPasswordResponse({
		status: response.status,
		statusText: response.statusText,
		newToken: response.data.newToken
	}) : null;
}

/**
 * @param {UnsubscribeRequest} unsubscribeRequest
 * @returns {Promise<?UnsubscribeResponse>}
 */
export const unsubscribe = async unsubscribeRequest => {
	const response = await axios.post(`${API_URL}/unsubscribe`, unsubscribeRequest, {headers});
	return response ? new UnsubscribeResponse(response) : null;
}

/**
 * @param {DeclineCoverageRequest} declineCoverageRequest
 * @returns {Promise<void>}
 */
export const declineCoverage = async declineCoverageRequest => {
	await axios.post(`${API_URL}/declineCoverage`, declineCoverageRequest, {headers});
}

/**
 * @param {PrepareSummaryRequest} prepareSummaryRequest
 * @returns {Promise<?PrepareSummaryResponse>}
 */
export const prepareSummaryService = async prepareSummaryRequest => {
	const response = await axios.post(`${API_URL}/prepareSummary`, prepareSummaryRequest, {headers});
	return response ? new PrepareSummaryResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {ScheduleEmailRecommendationRequest} scheduleEmailRecommendationRequest
 * @returns {Promise<void>}
 */
export const scheduleEmailRecommendation = async scheduleEmailRecommendationRequest => {
	await axios.post(`${API_URL}/scheduleEmailRecommendation`, scheduleEmailRecommendationRequest, {headers});
}

/**
 * @param {SubmitPlanInfoRequest} submitPlanInfoRequest
 * @returns {Promise<?SubmitPlanInfoResponse>}
 */
export const submitPlanInfo = async submitPlanInfoRequest => {
	const response = await axios.post(`${API_URL}/submitPlanInfo`, submitPlanInfoRequest, {headers});
	return response ? new SubmitPlanInfoResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

// pyments //

/**
 * @param {AddMicroDepositsOrBankAccountRequest} addMicroDepositsOrBankAccountRequest
 * @returns {Promise<?AddBankAccountResponse>}
 */
export const addBankAccount = async addMicroDepositsOrBankAccountRequest => {
	const response = await axios.post(`${API_URL}/addBankAccount`, addMicroDepositsOrBankAccountRequest, {headers});
	return response ? new AddBankAccountResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}

/**
 * @param {AddMicroDepositsOrBankAccountRequest} addMicroDepositsOrBankAccountRequest
 * @returns {Promise<void>}
 */
export const addMicroDeposits = async addMicroDepositsOrBankAccountRequest => {
	await axios.post(`${API_URL}/addMicroDepositsBankAccount`, addMicroDepositsOrBankAccountRequest, {headers});
}

/**
 * @param {RemoveBankAccountRequest} removeBankAccountRequest
 * @returns {Promise<void>}
 */
export const removeBankAccountService = async removeBankAccountRequest => {
	await axios.post(`${API_URL}/removeBankAccount`, removeBankAccountRequest, {headers});
}


/**
 * @param {RemoveMicroDepositsBankAccountRequest} removeMicroDepositsBankAccountRequest
 * @returns {Promise<void>}
 */
export const removeMicroDepositsBankAccountService = async removeMicroDepositsBankAccountRequest => {
	await axios.post(`${API_URL}/removeMicroDepositsBankAccount`, removeMicroDepositsBankAccountRequest, {headers});
}

/**
 * @param {ListConditionsWithKeywordRequest} listConditionsWithKeywordRequest
 * @returns {Promise<?ListConditionsWithKeywordResponse>}
 */
export const listConditionsWithKeyword = async listConditionsWithKeywordRequest => {
	const response = await axios.post(`${API_URL}/listConditionsWithKeyword`, listConditionsWithKeywordRequest, {headers});
	return response ? new ListConditionsWithKeywordResponse({
		status: response.status,
		statusText: response.statusText,
		data: response.data
	}) : null;
}